import styled from 'styled-components';

import { Checkbox, Button } from 'junto-ui';
import { tokens } from '@plataforma/components';
import { grid } from '_/styles';

export const Check = styled(Checkbox)`
  margin-top: 24px;
`;

export const Text = styled.span`
  margin-bottom: 0;

  a {
    font-weight: normal;
  }
`;

export const ActionButton = styled(Button)`
  width: 100%;
  margin-top: ${grid.large};
  font-family: ${tokens.font.family.metropolis};
  font-weight: ${tokens.font.weight.semibold};
`;

export const Container = styled.div`
  text-align: left;
`;

export const Title = styled.p`
  text-align: left;
  font-size: ${tokens.font.size.l};
  font-weight: ${tokens.font.weight.semibold};
`;
